import HeroComplex from './HeroComplex'
export default HeroComplex
